import React from "react";

const ProfileInfoCard = ({ icon, title, subtitle, children }) => {
  return (
    <div className="v2-prof-pg-card">
      <div className="v2-prof-pg-card__header">
        <span className="v2-prof-pg-card__icon">{icon}</span>
        <div>
          <h3 className="v2-prof-pg-card__title">{title}</h3>
          <p className="v2-prof-pg-card__subtitle">{subtitle}</p>
        </div>
      </div>
      <div className="v2-prof-pg-card__body">{children}</div>
    </div>
  );
};

export const ProfileField = ({
  label,
  value,
  icon,
  isEditing,
  onChange,
  name,
  type = "text",
  isTextarea = false,
  placeholder = "",
}) => {
  return (
    <div className="v2-prof-pg-field">
      <label className="v2-prof-pg-field__label">
        {icon && <span className="v2-prof-pg-field__label-icon">{icon}</span>}
        {label}
      </label>
      {isTextarea ? (
        <textarea
          className="v2-prof-pg-field__textarea"
          value={value || ""}
          onChange={onChange}
          name={name}
          disabled={!isEditing}
          placeholder={placeholder}
          rows={3}
        />
      ) : (
        <input
          className="v2-prof-pg-field__input"
          type={type}
          value={value || ""}
          onChange={onChange}
          name={name}
          disabled={!isEditing}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

export default ProfileInfoCard;
